module.exports = __webpack_public_path__ + "img/ibs_01.8ffc66f5.png";